import {
  Text,
  BorderRadius,
  Colors,
  Media,
  Spacing,
  StackChildren,
} from '@doordash/design-language'
import styled from 'styled-components'

export const PageContainer = styled(StackChildren)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;

  /* To allow mobile separators to flow outside parent */
  overflow-x: visible;
`

export const OrientationTypeContainer = styled.div`
  max-width: 360px;
  margin: 0 auto;
  border: 1px solid ${Colors.SystemGrey10};
  border-radius: ${BorderRadius.Medium}px;
  padding: ${Spacing.Medium}px ${Spacing.Small}px ${Spacing.Medium}px
    ${Spacing.Small}px;

  ${Media.Mobile`
    padding: 0 ${Spacing.Medium}px ${Spacing.Medium}px ${Spacing.Medium}px;
    border: none;
  `}
`

export const KitModalText = styled(Text).attrs<{}>({
  styles: Text.Styles.ContentAction,
})`
  font-weight: 700;
  cursor: pointer;
  padding-top: ${Spacing.Small}px;
  padding-bottom: ${Spacing.Small}px;

  &:hover {
    text-decoration: underline;
  }
`

export const OrientationTitleContainer = styled.div`
  ${Media.Mobile`
    padding-left: ${Spacing.XxxSmall}px;
    text-align: left;
  `}
`

export const OrientationTitle = styled(Text).attrs<{}>({
  styles: Text.Styles.ContentBody,
})`
  margin: ${Spacing.Large}px;
`

export const PageTitle = styled(Text).attrs<{}>({
  size: Text.Sizes.Small,
})``

export const MobileSeparator = styled.div`
  display: none;

  ${Media.Mobile`
    display: block;
    width: calc(100% + 25px);
    margin-left: -13px;
    height: ${Spacing.Small}px;
    background-color: ${Colors.SystemGrey0};
    border: 1px solid ${Colors.SystemGrey5};
  `}
`
